// extracted by mini-css-extract-plugin
export default {"content":"AccountDeleteModalContent_content__gpDKC"};